/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames';
import some from 'lodash/some'

import { Button } from 'primereact/button';
import { SplitButton } from 'primereact/splitbutton';
import { RadioButton } from 'primereact/radiobutton';
import { Checkbox  } from 'primereact/checkbox';

import { SET_VALUES_DOCUMENT } from '@constants/actionType';

import store from '@store';

class VisibilityForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      optionCountriesVisible: [],
      languagePreview: [],
      isAllCountriesVisible: false,
      errors: []
    };

    this.actions = [
      {
        label: this.props.t('Enviar a autorizar'),
        icon: 'pi pi-users',
        command: (e) => {
            this.onSubmit(() => this.props.authorize())
        }
      },
      {
          label: this.props.t('Autorizar'),
          icon: 'pi pi-check-circle',
          command: (e) => {
            this.onSubmit(() => this.props.authorize())
          }
      }
    ]
    this.actionsEdit = [
      {
        label: this.props.t('Enviar a autorizar'),
        icon: 'pi pi-users',
        command: (e) => {
          this.onSubmit(() => this.props.authorize())
        }
      },
      {
        label: this.props.t('Eliminar versión'),
        icon: 'pi pi-trash',
        command: (e) => {
          this.onSubmit(() => this.props.deleteVersion())
        }
      },
      {
          label: this.props.t('Autorizar'),
          icon: 'pi pi-check-circle',
          command: (e) => {
            this.onSubmit(() => this.props.authorize())
          }
      },
      {
        label: this.props.t('Rechazar'),
        icon: 'pi pi-times',
        command: (e) => {
          this.onSubmit(() => this.props.reject())
        }
      },
    ]
  }

  componentDidMount() {
    const {
      _visibility,
      itemsTabsLenguages,
      t
    } = this.props;
    if (_visibility) {
      this.setState({
        optionCountriesVisible: _visibility.optionCountry,
        isAllCountriesVisible: _visibility.isAllCountriesVisible
      });
    }
    const languagePreview = itemsTabsLenguages.map((item) => {
      const label = t('En') + ' ' + item.label.replace(`(${t('Obligatorio')})`, '')
      return {
        label,
        icon: 'pi pi-eye',
        command: () => {
          this.onPreview(`${item.key}`)
        }
      }
    })
    this.setState({ languagePreview })
    this.setState({ loadingPage: false });
  }

  onPreview = async (language) => {
    console.log('language', language)
  };



  onChange = ({ target }) => {
    const [language, name] = target.name.split('-');
    this.setState((prevState) => ({
      [language]: { ...prevState[language], [name]: target.value },
    }));
  };

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }

  validateFields = async () => {
    const { isAllCountriesVisible, optionCountriesVisible } = this.state
    let errors = {}
    if (!isAllCountriesVisible && !optionCountriesVisible.length ) errors = { ...errors, [`countriesSelect`]: 'countriesSelect es requerido' }
    this.setState({errors})
    return errors
  }

  onSubmit = async (onAction) => {
    const validate = await this.validateFields()
    if (some(validate, {})) return true
    const { success } = this.props;
    const { optionCountriesVisible, isAllCountriesVisible } = this.state;

    await store.dispatch({
      type: SET_VALUES_DOCUMENT,
      payload: { visibility: {optionCountry: optionCountriesVisible, isAllCountriesVisible} },
    });
    onAction()
  };

  onChangeCheck = (e) => {
    const { optionCountriesVisible } = this.state
    const selectedCountry = [...optionCountriesVisible];
    if(e.checked)
      selectedCountry.push(e.value);
    else
      selectedCountry.splice(selectedCountry.indexOf(e.value), 1);

    this.setState(
      {optionCountriesVisible: selectedCountry, isAllCountriesVisible: false},
      () => this.validateFieldsOnchange(`countriesSelect`, true)
    );
  }

  onChangeAllCountries = (e) => {
    this.setState({isAllCountriesVisible: e.value, optionCountriesVisible: []}, () => this.validateFieldsOnchange(`countriesSelect`, true))
  }

  render() {
    const { t, btnSubmitLoading, onBack, countriesCatalog, success, isEdit, keysLenguages } = this.props;
    const {
      loadingPage,
      optionCountriesVisible,
      errors,
      languagePreview
    } = this.state;

    const isFormFieldValid = (name) =>
      !!(errors[name]);
    const getFormErrorMessage = (name) =>
      isFormFieldValid(name) && (
        <small className="p-error">{errors[name]}</small>
      );

    const renderCountruiesOption = () => countriesCatalog.map(item => (
        <div className="p-field-checkbox" key={item.label}>
          <Checkbox
            inputId={`cb${item.id}`}
            name="optionCountriesVisible"
            value={item.id}
            onChange={this.onChangeCheck}
            checked={optionCountriesVisible.indexOf(item.id) !== -1}
            className={classNames({
              'p-invalid': isFormFieldValid(`countriesSelect`),
            })}
          />
          <label >{item.label}</label>
        </div>
      ))

    if (loadingPage) return true;
    return (
      <>
        <div className="p-grid p-justify-end">
          <div className="p-col-12 footer-btn p-mb-4 p-mt-4">
            <div className="p-d-flex p-jc-between">
              <Button
                label={t('Regresar')}
                type="button"
                className="p-button-secondary"
                onClick={() => onBack()}
              />
              <SplitButton
                label={t('Vista Previa')}
                icon="pi pi-eye"
                onClick={() => this.onPreview(keysLenguages[0])}
                className="p-button-info"
                model={languagePreview}
              />
              <SplitButton label={t('Guardar')} icon="pi pi-save" onClick={() => this.onSubmit(() => success())} model={isEdit ? this.actionsEdit : this.actions}/>
            </div>
          </div>
        </div>
        {/* <form onSubmit={this.onSubmit} autoComplete="false"> */}
          <div className="p-fluid p-grid p-mb-4">
            <div className="p-col-12 p-field">
                <label
                  htmlFor="title"
                  className={classNames('p-text-bold', {
                      'p-error': isFormFieldValid(`countriesSelect`),
                    })}
                >
                  {t('Seleccione los paìses para los cuales el documento sera visible')}
                </label>
                <div className="p-field-radiobutton">
                  <Checkbox
                    name="isAllCountriesVisible"
                    value
                    onChange={this.onChangeAllCountries}
                    checked={this.state.isAllCountriesVisible}
                    className={classNames({
                      'p-invalid': isFormFieldValid(`countriesSelect`),
                    })}
                  />
                  <label>{t('Todos los países')}</label>
                </div>
                { renderCountruiesOption() }
              </div>
            </div>
          {/* <div className="p-col-12 footer-btn">
            <div className="p-d-flex p-jc-between">
              <Button
                label={t('Regresar')}
                type="button"
                className="p-button-secondary"
                onClick={() => onBack()}
              />
              <Button
                label={t('Continuar')}
                type="submit"
                className="p-button-primary"
                loading={btnSubmitLoading}
              />
            </div>
          </div>
        </form> */}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  _visibility: state.document.visibility,
  countriesCatalog: state.catalogs.countriesCurrentCatalog,
  keysLenguages: state.catalogs.keysLanguageCatalog,
  itemsTabsLenguages: state.catalogs.tabsLanguageCatalog,
});

export default compose(
  withTranslation(),
  connect(mapStateToProps, null)
)(VisibilityForm);
